import type { ReactElement } from 'react';
import { Badge } from '@/components/atoms/badge';

export type LibraryPieceCardProps = {
  title: string;
  composer: string;
  forms: readonly string[];
  arrangementCount?: number;
  inRepertoire?: boolean;
  onClick?: () => void;
};

export function LibraryPieceCard({
  title, composer, forms, arrangementCount, inRepertoire = false, onClick,
}: LibraryPieceCardProps): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group text-left w-full p-4 bg-[var(--bg-surface)] border border-[var(--rule)] rounded-[var(--r-md)] hover:border-[var(--ink)] cursor-pointer transition-all"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="font-display text-[16px] font-semibold leading-tight text-[var(--ink)] group-hover:text-[var(--brand-ink)] truncate">{title}</div>
          <div className="text-[11px] text-[var(--ink-3)] mt-1 truncate">{composer}</div>
        </div>
        {inRepertoire && <Badge tone="ok" size="sm" icon="check">In repertoire</Badge>}
      </div>
      <div className="flex items-center gap-1 mt-3 flex-wrap">
        {forms.map((f) => (
          <span
            key={f}
            className="text-[10px] font-mono uppercase tracking-wider text-[var(--ink-3)] px-1.5 py-0.5 bg-[var(--bg-soft)] rounded"
          >
            {f}
          </span>
        ))}
        {arrangementCount != null && (
          <span className="text-[10px] text-[var(--ink-3)] ml-auto">
            {arrangementCount === 1 ? '1 arr' : `${arrangementCount} arrs`}
          </span>
        )}
      </div>
    </button>
  );
}
